// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Textarea-Icon.module.scss  */
.Textarea-Icon-module-Root_VwT {
  position: absolute;
  z-index: 3;
  top: 0;
  box-sizing: border-box;
  padding-top: 14px;
  padding-right: 18px;
  line-height: 0; }

.Textarea-Icon-module-leftSide_2Z8 {
  left: 0;
  padding-right: 0;
  padding-left: 12px; }

.Textarea-Icon-module-rightSide_2lI {
  right: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Textarea/Icon/Textarea-Icon.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc,EAAE;;AAElB;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,QAAQ,EAAE","sourcesContent":["/*  imported from Textarea-Icon.module.scss  */\n.Textarea-Icon-module-Root_VwT {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  box-sizing: border-box;\n  padding-top: 14px;\n  padding-right: 18px;\n  line-height: 0; }\n\n.Textarea-Icon-module-leftSide_2Z8 {\n  left: 0;\n  padding-right: 0;\n  padding-left: 12px; }\n\n.Textarea-Icon-module-rightSide_2lI {\n  right: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
